import { memo } from 'react';
import RiskAiDetection from '@Policy/AdvancedThreatProtection/PolicyTemplate/Filters/RiskAiDetection';

const RiskAi = memo(() => {
  return <RiskAiDetection />;
});

export default RiskAi;
